import { Component, Input } from "@angular/core";
import { Store } from "@ngrx/store";
import { GlobalState } from "../../../store/global/global.reducer";
import {
  LgLinkMenuComponent,
  LgLinkMenuItemComponent,
  LgLinkMenuItemTextComponent
} from "@legal-and-general/canopy";
import { LinkComponent } from "../Link/Link.component";
import { Observable } from "rxjs";
import { selectPageTitle } from "../../../store/global/global.selectors";
import { DynamicComponent } from "../../utils/dynamic-loader/dynamic.component";
import { CmsData } from "@dotcom-frontend/data";
import { NgClass } from "@angular/common";

@Component({
  selector: "dotcom-frontend-link-list",
  templateUrl: "./LinkList.component.html",
  styleUrl: "./LinkList.component.scss",
  standalone: true,
  imports: [
    LgLinkMenuComponent,
    LinkComponent,
    LgLinkMenuItemTextComponent,
    LgLinkMenuItemComponent,
    NgClass
  ]
})
export class LinkListComponent implements DynamicComponent {
  @Input() data: CmsData | undefined;
  pageTitle = "";
  pageTitle$: Observable<string> = this.store.select(selectPageTitle);

  constructor(private store: Store<{ global: GlobalState }>) {
    this.pageTitle$.subscribe((title) => {
      this.pageTitle = title;
    });
  }
}
